import { DELIVERY_COMPANIES, getDeliveryCompanyName } from '@/pages/oms/orders/utils/deliveryCompany';

/** Unknown stored codes stay visible, but new choices use the existing OMS list. */
export const deliveryCompanyLabel = (code: string | null | undefined): string =>
  !code || code === 'UNASSIGNED' ? 'Unknown' : getDeliveryCompanyName(code);

// Short company names fit the narrow edit column without cutting off the selected label.
const selectName = (code: string): string => {
  const company = DELIVERY_COMPANIES.find((c) => c.code === code);
  return company ? company.name.replace(/\s*\(.*\)$/, '') : code;
};

interface DeliveryCompanySelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean | undefined;
}

export function DeliveryCompanySelect({ label, value, onChange, disabled }: DeliveryCompanySelectProps) {
  const known = DELIVERY_COMPANIES.some((company) => company.code === value);
  return (
    <select
      className="form-select form-select-sm"
      aria-label={label}
      // Keep the full OMS label discoverable when the selected text is shortened.
      title={value ? deliveryCompanyLabel(value) : 'Unknown'}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
    >
      <option value="">Unknown</option>
      {value && !known && (
        <option value={value} title={`${deliveryCompanyLabel(value)} (${value})`}>
          {value}
        </option>
      )}
      {DELIVERY_COMPANIES.map((company) => (
        <option key={company.code} value={company.code} title={getDeliveryCompanyName(company.code)}>
          {selectName(company.code)}
        </option>
      ))}
    </select>
  );
}
